import { isNumber, sortBy } from 'lodash-es';
import React, { FC, HTMLAttributes, ReactNode } from 'react';
import classNames from '../../helpers/classNames';
import { Currency } from '../../services/apis/accommodation/types';
import FormattedCurrency from '../FormattedCurrency/FormattedCurrency';
import InputNumber from '../InputNumber/InputNumber';
import styles from './AccommodationItem.module.scss';

type ItemType = {
  id: number;
  label: string;
  subLabel?: string;
  description?: ReactNode;
  price?: number;
  quantity?: number;
  currency?: Currency;
  min?: number;
  max?: number;
};

interface AccommodationItemAddonsProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  title?: string;
  items: Array<ItemType>;
  disabled?: boolean;
  onChange: (item: ItemType, value: Pick<Required<ItemType>, 'quantity'>) => void;
}

const AccommodationItemAddons: FC<AccommodationItemAddonsProps> = props => {
  const { title, items, className, disabled, onChange } = props;

  return (
    <div className={className}>
      {title && <div className={classNames(styles.title, styles.colorPrimary)}>{title}</div>}
      {sortBy(items, 'label')?.map(item => (
        <div
          key={item.id}
          className={classNames(styles.itemBody, items.length > 1 && 'mb-5 mb-sm-4', 'my-3')}
        >
          <div className={styles.content}>
            <div className={styles.itemName}>
              {item.label}{' '}
              {item.subLabel && <span className={styles.colorMuted}>/ {item.subLabel}</span>}
            </div>
            {item.description && <div>{item.description}</div>}
          </div>
          <div className="d-flex align-items-center flex-shrink-0" style={{ gap: 16 }}>
            {!!item.price && !!item.currency && (
              <FormattedCurrency
                value={item.price}
                name={item.currency.name}
                className={styles.price}
              />
            )}
            {isNumber(item.quantity) && (
              <InputNumber
                min={item.min}
                max={item.max}
                disabled={disabled}
                value={item.quantity}
                onChange={quantity => onChange(item, { quantity })}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AccommodationItemAddons;
